/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeasurementRelation } from './MeasurementRelation';
import {
    MeasurementRelationFromJSON,
    MeasurementRelationFromJSONTyped,
    MeasurementRelationToJSON,
    MeasurementRelationToJSONTyped,
} from './MeasurementRelation';

/**
 * 
 * @export
 * @interface ObservationDto
 */
export interface ObservationDto {
    /**
     * 
     * @type {number}
     * @memberof ObservationDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservationDto
     */
    externalId?: string;
    /**
     * 
     * @type {number}
     * @memberof ObservationDto
     */
    dataLevelId?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationDto
     */
    entityId?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationDto
     */
    observableItemId?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationDto
     */
    dataTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservationDto
     */
    value?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ObservationDto
     */
    unitId?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservationDto
     */
    actionTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservationDto
     */
    entityExternalId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ObservationDto
     */
    measuredAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ObservationDto
     */
    relativeToOperationExternalId?: string | null;
    /**
     * 
     * @type {MeasurementRelation}
     * @memberof ObservationDto
     */
    relation?: MeasurementRelation | null;
}



/**
 * Check if a given object implements the ObservationDto interface.
 */
export function instanceOfObservationDto(value: object): value is ObservationDto {
    return true;
}

export function ObservationDtoFromJSON(json: any): ObservationDto {
    return ObservationDtoFromJSONTyped(json, false);
}

export function ObservationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ObservationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'dataLevelId': json['dataLevelId'] == null ? undefined : json['dataLevelId'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'observableItemId': json['observableItemId'] == null ? undefined : json['observableItemId'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'value': json['value'] == null ? undefined : json['value'],
        'unitId': json['unitId'] == null ? undefined : json['unitId'],
        'actionTypeId': json['actionTypeId'] == null ? undefined : json['actionTypeId'],
        'entityExternalId': json['entityExternalId'] == null ? undefined : json['entityExternalId'],
        'measuredAt': json['measuredAt'] == null ? undefined : (new Date(json['measuredAt'])),
        'relativeToOperationExternalId': json['relativeToOperationExternalId'] == null ? undefined : json['relativeToOperationExternalId'],
        'relation': json['relation'] == null ? undefined : MeasurementRelationFromJSON(json['relation']),
    };
}

export function ObservationDtoToJSON(json: any): ObservationDto {
    return ObservationDtoToJSONTyped(json, false);
}

export function ObservationDtoToJSONTyped(value?: ObservationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'externalId': value['externalId'],
        'dataLevelId': value['dataLevelId'],
        'entityId': value['entityId'],
        'observableItemId': value['observableItemId'],
        'dataTypeId': value['dataTypeId'],
        'value': value['value'],
        'unitId': value['unitId'],
        'actionTypeId': value['actionTypeId'],
        'entityExternalId': value['entityExternalId'],
        'measuredAt': value['measuredAt'] === null ? null : ((value['measuredAt'] as any)?.toISOString()),
        'relativeToOperationExternalId': value['relativeToOperationExternalId'],
        'relation': MeasurementRelationToJSON(value['relation']),
    };
}

